import Footer from 'modules/common/components/footer';
import Navbar from 'modules/common/components/navbar';
import WalletImage from 'modules/common/assests/images/wallet-img.png';
import BinanceImage from 'modules/common/assests/images/binance-img.png';
import SwapImage from 'modules/common/assests/images/swap-img.png';

export default function FAQPage() {
  return (
    <>
      <div className="bg-[url('/src/modules/common/assests/images/home-background.png')] bg-no-repeat bg-cover h-auto">
        <Navbar />
      </div>
      <div className='relative py-16 bg-black overflow-hidden'>
        <div className='relative px-4 sm:px-6 lg:px-8'>
          <div className='text-lg max-w-screen-lg mx-auto'>
            <h1>
              <span className='block text-base text-center text-[#00ce1b] font-semibold tracking-wide uppercase'>
                Wallets
              </span>
              <span className='mt-2 block text-3xl text-center leading-8 font-extrabold tracking-tight text-white sm:text-4xl'>
                What is crypto wallet?
              </span>
            </h1>
            <p className='mt-8 text-xl text-gray-300 leading-8'>
              A crypto wallet is a program that helps you buy, sell, and store
              your cryptocurrency and (in many cases) your NFTs. Think of it as
              your address on the blockchain— you can send and receive items
              from it, it stores your items, and you want to keep it locked and
              safe.
            </p>
          </div>
          <div className='mt-6 prose prose-green max-w-screen-lg text-gray-300 mx-auto'>
            <h2 className='text-white'>Types of crypto wallets</h2>
            <h3 className='text-gray-200'>Custodial vs. non-custodial</h3>
            <p>
              There are two types of crypto wallets: custodial (“hosted”) and
              non-custodial wallets. Custodial wallets are managed by a third
              party company, whereas a non-custodial wallet is not. Custodial
              wallets are like keeping your valuables in a storage facility, and
              non-custodial wallets are like keeping them in your safe at home.
              Custodial wallets therefore require less responsibility, but are
              at the mercy of the third party (like, if the storage facility was
              robbed). Non-custodial wallets give you full control, but also
              mean you have to be extra careful (like, not losing your key or
              accidentally throwing away something valuable when you reorganize
              your closet).
            </p>
            <h3 className='text-gray-200'>Software vs. hardware</h3>
            <p>
              Non-custodial wallets include software and hardware wallets. A
              software wallet is a program that lives on your computer or on
              your internet browser. This makes software wallets a great option
              for quickly and conveniently buying, selling, and transferring
              NFTs and cryptocurrency. A hardware wallet is a physical device
              that you plug into your computer to use. Because it’s not always
              connected to your computer or browser, it’s a great option for
              long-term secure storage, but is a bit less convenient for fast or
              frequent transactions. Different wallets support different
              blockchains, and not all wallets support NFTs. Here are some
              wallets compatible with GreenArt Coin Marketplace.
            </p>
            <ul>
              <li>Metamask</li>
              <li>Coinbase Wallet</li>
              <li>Trust Wallet</li>
            </ul>
            <h2 className='text-white'>How to set up a crypto wallet</h2>
            <p>
              The process of setting up a crypto wallet differs from wallet to
              wallet, but for this example we’re going to walk through the flow
              of setting up a Metamask wallet. Metamask is a non-custodial
              software wallet that’s popular for NFTs.
            </p>
            <h3 className='text-gray-200'>
              1. Download the wallet browser extension
            </h3>
            <p>
              Like many wallets, Metamask has a browser extension, an iOS app,
              and an Android app. You only need the browser extension to get
              started, so{' '}
              <a
                href='https://metamask.io/'
                className='text-gray-50 font-medium no-underline'
              >
                {' '}
                download that.
              </a>
            </p>
            <figure>
              <img className='w-full rounded-lg' src={WalletImage} alt='' />
              <figcaption>Metamask</figcaption>
            </figure>
            <h3 className='text-gray-200'>
              2. Open the browser extension and follow the prompts
            </h3>
            <p>
              Open the extension once it’s installed. You’ll be prompted to get
              started. Choose the option to set up a new wallet and follow the
              prompts.
            </p>
            <h3 className='text-gray-200'>
              3. Create and store your seed phrase in a secure location
            </h3>
            <p>
              During the setup process, you’ll be presented with your seed
              phrase.
              <span className='text-gray-200 font-medium'>
                {' '}
                Store your seed phrase in a safe place that no one else will be
                able to access. Never share your seed phrase with anyone.
              </span>
            </p>
            <h3 className='text-gray-200'>How to fund your crypto wallet</h3>
            <p>
              Now that your wallet is set up, you can buy NFTs! Although you can
              buy some NFTs with a credit or debit card using GreenArt Coin, you
              might need to have cryptocurrency in your wallet for the cases
              where that’s not an option.
            </p>
            <p>
              Every wallet is different, but there are two main ways to fund
              your crypto wallet:
            </p>
            <h4 className='text-gray-200'>
              Adding funds directly to your wallet
            </h4>
            <p>
              Many NFT-compatible wallets support adding cryptocurrency directly
              into your wallet by using a service such as Moonpay or Wyre. These
              are integrated into the wallet, and allows you to buy
              cryptocurrency using a credit or debit card and skip the process
              of using a crypto exchange. You may be prompted to verify your
              identity during this process.
            </p>
            <figure>
              <span className='flex justify-center'>
                <img className='w-96 rounded-lg' src={SwapImage} alt='' />
              </span>
              <span className='flex justify-center'>
                <figcaption>Moonpay</figcaption>
              </span>
            </figure>
            <h4 className='text-gray-200'>
              Transferring cryptocurrency from a crypto exchange
            </h4>
            <p>
              Another option is to buy cryptocurrency using an exchange like
              Coinbase, Binance, or Kraken. Usually, when you buy cryptocurrency
              using an exchange, the cryptocurrency will be deposited in a
              custodial wallet managed by that exchange, most of which are not
              compatible with NFTs. So in order to fund your crypto wallet that
              you’ll use for NFTs, you have to transfer the cryptocurrency from
              the custodial exchange wallet to your other wallet. For example,
              if you bought ETH using Binance, you’d need to send it from your
              custodial Binance wallet to your Metamask wallet to buy NFTs using
              that ETH.
            </p>
            <figure>
              <img className='w-full rounded-lg' src={BinanceImage} alt='' />
              <figcaption>Binance exchange</figcaption>
            </figure>
            <p>
              The advantage of this method is that there aren’t the same
              maximums that there might be when you deposit cryptocurrency
              directly into your wallet using a service like Moonpay or Wyre
            </p>
            <h3 className='text-gray-200'>How to protect your crypto wallet</h3>
            <p>
              Just like any other valuables, you’ll want to employ some best
              practices for keeping your crypto wallet safe. Here are some tips:
            </p>
            <ul>
              <li>
                <span className='text-gray-200 font-medium'>
                  Don’t reuse passwords:{' '}
                </span>
                Make sure your crypto wallet password isn’t being used on any of
                your other accounts.
              </li>
              <li>
                <span className='text-gray-200 font-medium'>
                  Protect your seed phrase:{' '}
                </span>
                When you set your wallet up, store your seed phrase somewhere
                you won’t forget, but isn’t easily accessible by others. Never
                share your seed phrase with anyone.
              </li>
              <li>
                <span className='text-gray-200 font-medium'>
                  Don’t click links you don’t recognize:{' '}
                </span>
                This is especially true if someone sent you a link directly.
              </li>
            </ul>
            <h3 className='text-gray-200'>
              Connecting your crypto wallet to GreenArt Coin
            </h3>
            <p>
              Once your crypto wallet is set up, connecting it to GreenArt Coin
              is easy. Click the wallet icon in the top right corner of the
              GreenArt Coin site and it’ll walk you through connecting your
              wallet. From here, you can fill out the rest of your GreenArt Coin
              profile.
            </p>
            <p>
              Any time you try to take an action that gets recorded on the
              blockchain, like purchasing an NFT, you’ll be prompted to connect
              your wallet and authorize the action. You must have your wallet
              connected in order to buy, sell, create, or transfer NFTs using
              GreenArt Coin.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
